export const extractAISQLAssistSuggestionText = (responseText: string): string => {
    const trimmedResponseText = responseText.trim();

    if (trimmedResponseText.length === 0) {
        return '';
    }

    const preferredBlockLabels = [
        'updated query',
        'updated sql',
        'suggested query',
        'suggested sql',
        'suggested source query',
        'suggested where clause',
        'final query',
        'final sql',
        'drop-in sql',
        'drop in sql',
    ];

    for (const preferredBlockLabel of preferredBlockLabels) {
        const preferredBlockMatch = new RegExp(`${preferredBlockLabel}:\\s*\`\`\`(?:sql)?\\s*([\\s\\S]*?)\`\`\``, 'i')
            .exec(trimmedResponseText);

        if (preferredBlockMatch && preferredBlockMatch[1]) {
            return preferredBlockMatch[1].trim();
        }
    }

    const codeBlockMatches = Array.from(trimmedResponseText.matchAll(/```(?:sql)?\s*([\s\S]*?)```/gi));

    if (codeBlockMatches.length > 0) {
        const lastCodeBlockMatch = codeBlockMatches[codeBlockMatches.length - 1];

        return lastCodeBlockMatch[1].trim();
    }

    let suggestionText = trimmedResponseText;
    const knownPrefixes = [
        'Suggested WHERE Clause:',
        'Suggested Where Clause:',
        'Suggested Source Query:',
        'Suggested Query:',
        'Suggested SQL:',
        'Updated Query:',
        'Updated SQL:',
        'Final Query:',
        'Final SQL:',
        'SQL:',
    ];

    knownPrefixes.forEach((knownPrefix) => {
        if (suggestionText.toLowerCase().startsWith(knownPrefix.toLowerCase())) {
            suggestionText = suggestionText.substring(knownPrefix.length).trim();
        }
    });

    const stopMarkers = [
        '\nExplanation:',
        '\nNotes:',
        '\nNote:',
        '\nAncillary Information:',
        '\nAssumptions:',
        '\nWarnings:',
        '\nWarning:',
        '\nReasoning:',
        '\nWhy:',
    ];

    const firstStopMarkerIndex = stopMarkers
        .map((stopMarker) => suggestionText.toLowerCase().indexOf(stopMarker.toLowerCase()))
        .filter((stopMarkerIndex) => stopMarkerIndex >= 0)
        .sort((left, right) => left - right)[0];

    if (firstStopMarkerIndex !== undefined) {
        suggestionText = suggestionText.substring(0, firstStopMarkerIndex).trim();
    }

    return suggestionText;
};
